import {
  HANDLE_ERROR,
  HANDLE_LOADING,
  ANALYTICS_CUSTOMER,
  ANALYTICS_INTENT,
  ANALYTICS_UTTERANCES,
  ANALYTICS_APP_LIST,
  ANALYTICS_MESSAGE,
  CREATE_API_KEY,
  ANALYTICS_SKILL_ACTIVATION,
  ANALYTICS_SUMMARY,
  ANALYTICS_CONVERSATIONAL_PATH,
  DELETE_APP,
} from "./actionTypes";

const initialState = {
  analytics_summmary: null,
  analytics_customer: null,
  analytics_intent: null,
  analytics_utterances: null,
  analytics_app_list: null,
  analytics_messages: null,
  analytics_skill_activation: null,
  analytics_conversational_path: null,
  isLoading: false,
  error: null,
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case ANALYTICS_CUSTOMER:
      return { ...state, analytics_customer: action.payload, error: null };
    case ANALYTICS_SUMMARY: {
      return { ...state, analytics_summmary: action.payload, error: null };
    }
    case DELETE_APP: {
      let new_list = state.analytics_app_list.filter(
        (apps) => apps !== action.payload
      );
      return { ...state, analytics_app_list: new_list, error: null };
    }
    case ANALYTICS_CONVERSATIONAL_PATH: {
      return {
        ...state,
        analytics_conversational_path: action.payload,
        error: null,
      };
    }
    case ANALYTICS_SKILL_ACTIVATION:
      return {
        ...state,
        analytics_skill_activation: action.payload,
        error: null,
      };
    case ANALYTICS_INTENT:
      return { ...state, analytics_intent: action.payload, error: null };
    case ANALYTICS_UTTERANCES: {
      return { ...state, analytics_utterances: action.payload, error: null };
    }
    case ANALYTICS_APP_LIST: {
      let data = action.payload && action.payload.data[0][0];
      if (data) return { ...state, analytics_app_list: data, error: null };
      return { ...state, analytics_app_list: null, error: null };
    }
    case HANDLE_LOADING:
      return { ...state, isLoading: action.payload };
    case CREATE_API_KEY: {
      if (state.analytics_app_list)
        return {
          ...state,
          analytics_app_list: [...state.analytics_app_list, action.payload],
        };
      return { ...state, analytics_app_list: [action.payload] };
    }
    case HANDLE_ERROR:
      return { ...state, error: action.payload };
    case ANALYTICS_MESSAGE: {
      return { ...state, analytics_messages: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
